import React from 'react';

import { Alert, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import { BulkPatchSupplierPropertyCommitRow, BulkPatchSupplierPropertyField } from '~/services/BedbankService';

const PATCH_FIELDS: Array<BulkPatchSupplierPropertyField> = [
  'supplierPropertyId',
  'travelgateId',
  'supplierEnabled',
  'metasearchEnabled',
];

function renderCommitValue(row: BulkPatchSupplierPropertyCommitRow, field: BulkPatchSupplierPropertyField) {
  if (typeof row[field] === 'undefined') {
    return '-';
  }

  return `${row[field] ?? 'null'}`;
}

interface Props {
  rows: Array<BulkPatchSupplierPropertyCommitRow>;
}

export default function BulkSupplierPropertyUpdateCommitTable({ rows }: Props) {
  if (rows.length === 0) {
    return <Alert severity="info">Committed rows will display here.</Alert>;
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Property ID</TableCell>
          <TableCell>Supplier</TableCell>
          <TableCell>Supplier Property ID</TableCell>
          <TableCell>Travelgate ID</TableCell>
          <TableCell>Supplier Enabled</TableCell>
          <TableCell>Metasearch Enabled</TableCell>
          <TableCell>Error</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => (
          <TableRow
            key={`${row.propertyId}:${row.supplier}`}
            sx={row.error ? { '& > td': { backgroundColor: 'rgba(211, 47, 47, 0.08)' } } : undefined}
          >
            <TableCell>{row.propertyId}</TableCell>
            <TableCell>{row.supplier}</TableCell>
            {PATCH_FIELDS.map((field) => (
              <TableCell key={field}>{renderCommitValue(row, field)}</TableCell>
            ))}
            <TableCell>{row.error ?? '-'}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
